import angular from 'angular';
import '../../services/user';
import '../../services/globals';
import '../../services/notifications';
import '../../services/errors';
import Lodash from 'lodash';

const module = angular.module('whyline.modals.organization-users-mass-load', [
    'whyline.services.user',
    'whyline.services.globals',
    'whyline.services.notifications',
    'whyline.services.errors',
]);

const OrganizationUsersMassLoadModalController = function (
  $uibModalInstance,
  $scope,
  UserService,
  NotificationService,
  ErrorService,
  $translate
) {
  'ngInject';

  $scope.showUploadButton = true;
  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };
  $scope.succesMessage = '';

  async function processUpload(uploadTask, limit) {
    try {
      const result = await uploadTask();
      const { users, errors } = Lodash.get(result, 'data', result);
      $scope.errorsThen = [];
      Lodash.map(errors, error => {
        const errorToShow = Lodash.merge(error, { limit, counter: $scope.counter });
        $scope.errorsThen.push(errorToShow)
      });

      if (users.length) {
        NotificationService.Success($translate.instant('users_uploaded').replace('{count}', `${users.length}`));
      }

      $scope.counter++;

      return users.length;
    } catch(error) {
      $scope.errorsThen = [];
      $scope.errorsThen.push({ reason: error.reason || error.data });
      ErrorService.handler(error);
      return 0;
    }
  }

  async function runSerial(tasks, limit) {
    for(const task of tasks) {
      const fatalErrorFound = Object.values($scope.errorFlags).reduce((p, c) => p || c);
      if (fatalErrorFound) {
        throw new Error('fatal error exception');
      }
      $scope.usersCreated += await processUpload(task, limit);
    }

    if ($scope.usersCreated) {
      return NotificationService.Success($translate.instant('users_uploaded_{{count}}', { count: $scope.usersCreated }));
    } else {
      return NotificationService.Warning($translate.instant('users_no_user_created'));
    }
  }

  $scope.uploadFiles = async file => {
    $scope.errorFlags = {
      headers: false,
    };
    $scope.errorsThen = null;
    $scope.usersCreated = null;
    $scope.missingRequiredValueMessages = [];
    $scope.counter = 0;
    $scope.file = file;

    const limit = 100;

    if (file && file.type === 'text/csv') {
      $scope.showUploadButton = false;
      const { usersCount, tasks } = await UserService.Upload(file, limit);
      $scope.totalUsers = usersCount;
      const result = await runSerial(tasks, limit);
      $scope.succesMessage = $translate.instant('users_created_message', { usersCreated: $scope.usersCreated, totalCount: $scope.totalCount });
      $scope.showUploadButton = true;
      return result;
    } else if (file && file.type !== 'text/csv') {
      NotificationService.Warning($translate.instant('invalid_file_format'));
    }
  };

  $scope.getAlreadyExistsMessage = (email, place) => {
    return $translate.instant('user_already_exists', { email: email, placeId: place });
  }

  $scope.getDuplicatePermissiosMessage = (email) => {
    return $translate.instant('duplicate_permissions', { email: email });
  }
};

module.exports = module.controller('OrganizationUsersMassLoadModalController', OrganizationUsersMassLoadModalController);
